// extracted by mini-css-extract-plugin
export default {"wrapper":"AboutPage_wrapper__yTlX4","inner":"AboutPage_inner__b-tKQ","documentsItem":"AboutPage_documentsItem__E2smY","icon":"AboutPage_icon__PRQI8"};